
import type { ComputedRef } from 'vue'
import type { AppBadgeColor } from '../../app-badge'
import type { BadgeTutorStatusProps } from '../types/interfaces'

import { useListsStore } from '@shared/model'
import { TutorStatus } from '@shared/config'

import { useBadgeFromStatus } from '../../app-badge'

interface BadgeTutorStatusOptions {
  props: BadgeTutorStatusProps
}

interface BadgeTutorStatusReturn {
  color: ComputedRef<AppBadgeColor>
  text: ComputedRef<string>
  visible: ComputedRef<boolean>
}

const STATUS_COLORS: Record<TutorStatus, AppBadgeColor> = {
  [TutorStatus.Active]: 'emerald',
  [TutorStatus.Onboarding]: 'blue',
  [TutorStatus.Disabled]: 'red',
  [TutorStatus.Draft]: 'slate',
}

export const useBadgeTutorStatus = ({ props }: BadgeTutorStatusOptions): BadgeTutorStatusReturn => {
  const listsStore = useListsStore()

  const { color, text } = useBadgeFromStatus<TutorStatus>({
    status: () => props.status,
    colors: STATUS_COLORS,
    labels: () => listsStore.getLists?.tutor.status,
  })

  const visible = computed<boolean>(() => text.value !== '')

  return {
    color,
    text,
    visible,
  }
}
